<template>
  <!--查看-->
  <div class="manager-edit-view">
    <div class="switch-company">
      <span :class="['switch-text', isFillCompany ? '' : 'active']" @click="handleChangeFillCompany(false)">个人填报</span>
      <span :class="['switch-text', isFillCompany ? 'active' : '']" @click="handleChangeFillCompany(true)">单位填报</span>
    </div>
    <el-form
      :model="formData"
      :rules="rules"
      v-loading="saveLoading"
      ref="integrateAddForm"
      size="small"
      label-width="130px"
      class="form-horizontal flex-column detail-form paddingTopDetail integrateEditDetail"
      :class="'detail-edit-form'"
    >
      <el-collapse v-model="activeNames">
        <el-collapse-item title="经营人信息" name="2">
          <div class="detail-box" style="display: flex; flex-wrap: wrap">
            <el-form-item prop="realManagerName" label="经营人：">
              <el-input v-model="formData.realManagerName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="realManagerPhone" label="联系电话：">
              <el-input v-model="formData.realManagerPhone" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="realManagerCertType" label="证件种类：">
              <el-select v-model="formData.realManagerCertType" filterable placeholder="请选择">
                <el-option
                  v-for="item in selOptions.realManagerCertType"
                  :key="item.name"
                  :label="item.value"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="realManagerCertCode" label="证件号码：">
              <el-input v-model="formData.realManagerCertCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="realManagerFirstName" label="外文姓：">
              <el-input v-model="formData.realManagerFirstName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="realManagerLastName" label="外文名：">
              <el-input v-model="formData.realManagerLastName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="realManagerCountry" label="国籍：">
              <el-select v-model="formData.realManagerCountry" filterable placeholder="请选择">
                <el-option v-for="item in selOptions.realManagerCountry" :key="item.name" :label="item.value" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-width-100" prop="realManagerAddr" label="实际居住地：">
              <el-input v-model="formData.realManagerAddr" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-collapse-item>
        <el-collapse-item v-show="isFillCompany" title="经营单位信息" name="3">
          <div class="detail-box" style="display: flex; flex-wrap: wrap">
            <el-form-item class="sp-width-100" prop="companyName" label="经营单位：">
              <el-autocomplete
                class="sp-width-100"
                v-model="formData.companyName"
                :fetch-suggestions="filterCompanyList"
                placeholder="请输入"
                @select="handleCompanySelect"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item prop="companyCreditCode" label="社会信用代码：">
              <el-input v-model="formData.companyCreditCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="companyPhone" label="单位联系电话：">
              <el-input v-model="formData.companyPhone" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="corporationName" label="法人：">
              <el-input v-model="formData.corporationName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="corporationPhone" label="法人联系电话：">
              <el-input v-model="formData.corporationPhone" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="corporationCertType" label="法人证件种类：">
              <el-select v-model="formData.corporationCertType" filterable placeholder="请选择">
                <el-option
                  v-for="item in selOptions.corporationCertType"
                  :key="item.name"
                  :label="item.value"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="corporationCertCode" label="法人证件号码：">
              <el-input v-model="formData.corporationCertCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="corporationFirstName" label="法人外文姓：">
              <el-input v-model="formData.corporationFirstName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="corporationLastName" label="法人外文名：">
              <el-input v-model="formData.corporationLastName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="corporationCountry" label="法人国籍：">
              <el-select v-model="formData.corporationCountry" filterable placeholder="请选择">
                <el-option
                  v-for="item in selOptions.corporationCountry"
                  :key="item.name"
                  :label="item.value"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-width-100" prop="corporationAddr" label="法人实际居住地：">
              <el-input v-model="formData.corporationAddr" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div style="text-align: center; padding: 20px">
        <el-button class="primary-btn-g" icon="CircleCheck" @click="handleSave">保存</el-button>
        <el-button class="warning-btn-g" icon="CircleClose" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import RichText from '@/components/common/RichText/RichText'
import { mapActions } from 'vuex'
import moment from 'moment'
import formCheck from '@/components/common/formCheck'

export default {
  mixins: [formCheck],
  components: { RichText },
  name: 'publishDetailModel',
  props: {
    selOptions: {
      type: Object,
      default: { realManagerCountry: [], realManagerCertType: [], corporationCountry: [], corporationCertType: [] },
    },
    detailModal: {
      type: Boolean,
      default: '',
    },
    detailData: {
      type: Object,
      default: {},
    },
    detailType: {
      type: String,
      default: 'show',
    },
  },
  data() {
    let detailKeys = [
      'realManagerName',
      'realManagerCountry',
      'realManagerCertType',
      'realManagerCertCode',
      'realManagerFirstName',
      'realManagerLastName',
      'realManagerPhone',
      'realManagerAddr',
      'companyName',
      'companyCreditCode',
      'companyPhone',
      'corporationName',
      'corporationCountry',
      'corporationCertType',
      'corporationCertCode',
      'corporationFirstName',
      'corporationLastName',
      'corporationPhone',
      'corporationAddr',
      'wyfptdwbm',
      'sbrq',
      'jyzbm',
    ]
    let formData = {}
    detailKeys.map((key) => {
      formData[key] = ''
    })

    return {
      isFillCompany: false,

      companyList: [],
      isValid: true,
      activeNames: ['1', '2', '3', '4', '5', '6', '7'],
      showType: '',
      saveLoading: false,
      detailKeys: detailKeys,
      rules: {
        realManagerName: [{ required: true, message: '请输入', trigger: 'blur' }],
        realManagerCountry: [{ required: true, message: '请输入', trigger: 'blur' }],
        realManagerCertType: [{ required: true, message: '请输入', trigger: 'blur' }],
        realManagerCertCode: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.beforeCheckIDCardCode, trigger: 'blur' },
        ],
        companyName: [{ validator: this.checkCompanyName, trigger: 'blur' }],
        companyPhone: [{ validator: this.beforeCheckCompanyTel, trigger: 'blur' }],
        companyCreditCode: [{ validator: this.beforeCheckSocialCode, trigger: 'blur' }],
        corporationCertCode: [{ validator: this.beforeCheckFarenCode, trigger: 'blur' }],
        corporationName: [{ validator: this.checkFarenName, trigger: 'blur' }],
        realManagerPhone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkTel, trigger: 'blur' },
        ],
        corporationPhone: [{ validator: this.beforeCheckFarenTel, trigger: 'blur' }],
      },
      formData: formData,

      areaCascaderProps: {
        lazy: true,
        emitPath: true,
        checkStrictly: true,
        lazyLoad: this.getStateNext,
      },
    }
  },
  created() {
    this.searchCompany()
  },
  mounted() {
    this.showType = this.detailType
  },
  watch: {
    detailType(val) {
      this.showType = val
    },
    detailModal: {
      immediate: true,
      handler: function (to) {
        // return console.log(this.detailData, this.formData, '=============== form');
        if (to === false) {
          return false
        }
        this.isShowCompany = false
        if (this.detailType == 'add') {
          this.detailKeys.map((key) => {
            this.formData[key] = ''
          })
          this.formData.wyfptdwbm = 'aaaaa' //平台编码不可删除
          this.formData.sbrq = moment().format('YYYY-MM-DD HH:mm:ss')

          for (let selName in this.selOptions) {
            if (selName == 'realManagerCertType' || selName == 'corporationCertType') {
              this.selOptions[selName].length && (this.formData[selName] = this.selOptions[selName][0].name)
            }
          }
          this.formData.realManagerCountry = '156'
          this.formData.corporationCountry = '156'
        }

        if (this.detailType == 'edit') {
          this.detailKeys.map((key) => {
            this.formData[key] = this.detailData[key] ? this.detailData[key] : ''
          })
          if (this.detailData.companyCreditCode) {
            this.isFillCompany = true
          }
          // this.formData.areaCodes = [this.formData.provinceCode, this.formData.cityCode, this.formData.areaCode, this.formData.streetOffice,this.formData.neighborCmm].filter((item)=>{  return (item!=null && item!='')})
          
          // this.handleAreaSelChange()
        }
      },
    },
  },
  methods: {
    ...mapActions(['alertToggle', 'fetchData']),
    /**
     * 检验是否填写了企业信息
     * 填了，但没填完，返回 false
     * 填了，但是填完了，返回 true
     * 一个都没填，返回 true
     */
    checkIfWriteCompanyInfo() {
      let props = ['companyName', 'companyCreditCode', 'companyPhone', 'corporationName', 'corporationPhone', 'corporationCertCode']
      let flag = undefined
      for (let i = 0; i < props.length; i++) {
        if (flag === undefined) {
          flag = !!this.formData[props[i]]
        } else {
          let temp = !!this.formData[props[i]]
          if (flag != temp) return false
        }
      }

      return true
    },
    // 校验法人身份证号
    beforeCheckFarenCode(rule, value, callback) {
      let checkRes = this.checkIfWriteCompanyInfo()
      if (!checkRes && (value == '' || value == null)) {
        callback(new Error('请输入证件号码'))
      } else {
        this.beforeCheckIDCardCode(rule, value, callback)
      }
    },
    // 校验法人电话
    beforeCheckFarenTel(rule, value, callback) {
      let checkRes = this.checkIfWriteCompanyInfo()
      if (!checkRes && (value == '' || value == null)) {
        callback(new Error('请输入联系电话'))
      } else {
        this.checkTel(rule, value, callback)
      }
    },
    // 校验单位电话
    beforeCheckCompanyTel(rule, value, callback) {
      let checkRes = this.checkIfWriteCompanyInfo()
      if (!checkRes && (value == '' || value == null)) {
        callback(new Error('请输入联系电话'))
      } else {
        this.checkTel(rule, value, callback)
      }
    },
    // 校验信用代码
    beforeCheckSocialCode(rule, value, callback) {
      let checkRes = this.checkIfWriteCompanyInfo()
      if (!checkRes && (value == '' || value == null)) {
        callback(new Error('请输入社会信用代码'))
      } else {
        this.checkSocialCode(rule, value, callback)
      }
    },
    // 校验法人名称
    checkFarenName(rule, value, callback) {
      let checkRes = this.checkIfWriteCompanyInfo()
      if (!checkRes && (value == '' || value == null)) {
        callback(new Error('请输入法人名称'))
      } else {
        callback()
      }
    },
    // 校验单位名称
    checkCompanyName(rule, value, callback) {
      let checkRes = this.checkIfWriteCompanyInfo()
      if (!checkRes && (value == '' || value == null)) {
        callback(new Error('请输入单位名称或选择单位'))
      } else {
        callback()
      }
    },
    // 校验前的判定
    beforeCheckIDCardCode(rule, value, callback) {
      if (this.formData.realManagerCertType == '111' || this.formData.realManagerCertType == '112' || this.formData.realManagerCertType == '113') {
        this.checkIDCardCode(rule, value, callback)
      } else {
        callback()
      }
    },
    //保存与发布
    handleSave() {
      if (this.saveLoading) return

      this.saveLoading = true
      this.trimFormData()
      this.$refs['integrateAddForm'].validate((valid) => {
        if (valid && this.isValid) {
          if (this.detailType === 'edit') {
            this.checkIsExist('edit')
          } else {
            this.checkIsExist('add')
          }
        } else {
          this.$message.warning('请完善信息！')
          this.saveLoading = false
          return false
        }
      })
    },
    // 检测是否已存在
    checkIsExist(type) {
      let url = 'SAAS.OPRATER_VALIDATE'
      let params = {
        params: JSON.stringify({ realManagerCertCode: this.formData.realManagerCertCode, companyCreditCode: this.formData.companyCreditCode }),
      }

      this.fetchData({ url, method: 'get', params }).then((res) => {
        if (type === 'add') {
          if (res.orgList && res.orgList.length) {
            this.$confirm('经营信息已存在，确认覆盖？', '温馨提示', {
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
              this.doSave('cover', res.orgList[0].id)
            }).catch(() => {
              this.saveLoading = false
            })
          } else {
            this.doSave()
          }
        } else if (type === 'edit') {
          if (res.orgList && res.orgList.length) {
            let info = res.orgList[0]
            if (info.id != this.detailData.id) {
              this.saveLoading = false
              return this.$message.error('已存在的经营者信息，变更失败')
            } else {
              this.doSave()
            }
          } else {
            this.doSave()
          }
        }
      }).finally(() => {
        this.saveLoading = false
      })
    },
    doSave(type, resId) {
      let url = 'SAAS.OPRATER_UPDATE'
      let paramData = { ...this.formData }
      // paramData.provinceCode = paramData.areaCodes[0]
      // paramData.cityCode = paramData.areaCodes[1]?paramData.areaCodes[1]:''
      // paramData.areaCode = paramData.areaCodes[2]?paramData.areaCodes[2]:''
      // paramData.streetOffice = paramData.areaCodes[3]?paramData.areaCodes[3]:''
      // paramData.neighborCmm = paramData.areaCodes[4]?paramData.areaCodes[4]:''
      delete paramData.areaCodes

      if (this.detailType == 'edit') {
        paramData.id = this.detailData.id

        if (!this.noCheckFunc) {
          paramData.isExamine = 1
        }
      } else if (type === 'cover') {
        paramData.id = resId
      } else {
        paramData.id = ''
      }
      if (!paramData.id) delete paramData.jyzbm
      
      paramData.gxsj = moment().format('YYYY-MM-DD HH:mm:ss')
      let params = { params: JSON.stringify(paramData) }

      this.fetchData({ url: url, method: 'post', params: params, timeout: 0, isLoading: false, flag: true })
        .then((res) => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.$emit('submitSuccess')
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        })
        .catch((err) => {
          this.$message.error('操作失败！')
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    // 查询单位
    searchCompany() {
      let url = 'SAAS.OPRATER_COMPANY_SEARCH'
      let params = {
        params: JSON.stringify({ companyName: '' }),
      }

      this.fetchData({ url, method: 'get', params }).then((res) => {
        let temp = (res && res.orgList) ? (res.orgList || []) : []
        temp.forEach((item) => {
          item.value = `${item.companyName || '--'}（${item.companyCreditCode || '--'}）`
        })
        this.companyList = temp
      })
    },
    // 获取单位列表
    filterCompanyList(queryString, cb) {
      let list = this.companyList
      let results = queryString ? list.filter(this.createFilter(queryString)) : list
      cb(results)
    },
    createFilter(queryString) {
      return (list) => {
        return list.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    // 处理单位选中
    handleCompanySelect(val) {
      this.formData.companyName = val.companyName
      this.formData.companyCreditCode = val.companyCreditCode
      this.formData.companyPhone = val.companyPhone
      this.formData.corporationName = val.corporationName
      this.formData.corporationPhone = val.corporationPhone
      this.formData.corporationCertType = val.corporationCertType
      this.formData.corporationCertCode = val.corporationCertCode
      this.formData.corporationFirstName = val.corporationFirstName
      this.formData.corporationLastName = val.corporationLastName
      this.formData.corporationCountry = val.corporationCountry
      this.formData.corporationAddr = val.corporationAddr
    },
    handleCancel() {
      this.$refs.integrateAddForm.clearValidate()
      this.$emit('closeModel')
    },
    // 处理区域变更
    handleAreaSelChange() {
      let codes = this.formData.areaCodes
      if (!codes || codes.length === 0) return

      let province = codes[0] || undefined
      let city = codes[1] || undefined
      let region = codes[2] || undefined

      let url = 'SAAS.AUDIT_CONFIG_QUERY_ONE'

      let params = {
        params: JSON.stringify({ province, city, region }),
        start: 0,
        size: 1,
        toExcel: false,
      }

      this.noCheckFunc = false
      this.fetchData({ url, method: 'get', params })
        .then((res) => {
          if (res && res.data) {
            let temp = res.data || {}
            if (temp.id) {
              this.noCheckFunc = temp.operateStatus == 2
            }
          }
        })
    },
    // 省市区,树形结构
    getStateNext(node, resolve) {
      let code = node.level == 0 ? 0 : node.value
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'

      let params = {
        areaCode: code,
      }
      this.fetchData({ url, method: 'get', params }).then((res) => {
        let tempArr = []
        res.data.forEach((re) => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              leaf: node && node.level == 4 ? true : false,
            })
          }
          if (re.name) {
            tempArr.push({
              value: re.policeCode,
              label: re.name,
              leaf: node && node.level == 4 ? true : false,
            })
          }
        })
        resolve(tempArr)
      })
    },
    // 处理个人填报和单位填报切换
    handleChangeFillCompany(flag) {
      this.isFillCompany = flag
      if (!this.isFillCompany) {
        this.clearCompanyForm()
      }
    },
    // 清除单位填报信息
    clearCompanyForm() {
      let emptyCompanyInfo = {
        companyName: '',
        companyCreditCode: '',
        companyPhone: '',
        corporationName: '',
        corporationPhone: '',
        corporationCertType: '',
        corporationCertCode: '',
        corporationFirstName: '',
        corporationLastName: '',
        corporationCountry: '',
        corporationAddr: ''
      }

      Object.assign(this.formData, emptyCompanyInfo)
    }
  },
}
</script>

<style lang="less" scoped>
.manager-edit-view {
  position: relative;
  padding-top: 30px;
}
.integrateEditDetail.detail-edit-form {
  width: 90%;
}
.integrateEditDetail.detail-edit-form .el-form-item {
  width: 50%;
}
.integrateEditDetail.detail-edit-form .el-form-item.rowItem {
  width: 100%;
}
.integrateEditDetail .detailContent {
  padding: 0px;
}
.sentContent {
  margin: 20px;
  padding: 10px;
  border: 1px solid rgba(38, 118, 165, 1);
}
.sentContentTitle {
  text-align: center;
}
.switch-company {
  position: absolute;
  top: 0px;
  right: 5%;
  display: flex;
  align-items: center;
  border: 1px solid rgba(204, 204, 204, 1);
  .switch-text {
    display: block;
    text-align: center;
    width: 120px;
    line-height: 30px;
    cursor: pointer;
    transition: background-color 200ms, color 200ms;
    &.active {
      color: white;
      background-color: rgba(1, 192, 192, 1);
    }
  }
}
.sp-width-100 {
  width: 100% !important;
}
</style>
<style lang="less" >
.integrateEditDetail .w-e-text-container {
  border: 1px solid #2676a5 !important;
}

.theme-darkblue .el-autocomplete-suggestion__wrap {
  background: unset !important;
}
.theme-darkblue .el-autocomplete-suggestion__wrap li:hover {
  background: rgba(8, 122, 252, 0.5) !important;
}
</style>

